import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock10 as Block } from "./HomepageBlock10";
import { defaultData } from "./HomepageBlock10DefaultData";
import { meta } from "./HomepageBlock10MetaData";
import imagePreview from "./homepage_block_10_preview.png";

export const HomepageBlock10: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta,
};
